export default __webpack_public_path__ + "static/media/takeselfie_btn.b347b712.png";